import { NumberFormat } from '@billy/design-system'

export const getFormattedBalance = (balance: number, isBalanceTypeRelative: boolean) => {
  if (isBalanceTypeRelative) {
    return (
      NumberFormat.getFormattedNumber(balance || 0, 'NL', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }) + '%'
    )
  }

  return NumberFormat.getFormattedNumber(balance || 0, 'NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}
